import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Col, Form, Input, Row } from "antd";
import {
  useConfirmSessionIdMutation,
  useCreateRestaurantMutation,
} from "./register.service";
import { toast } from "react-toastify";
import "../login/style.css";

export default function CreateRestaurantPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const query = new URLSearchParams(useLocation().search);
  const sessionId = query.get("sessionId");

  const [requestCreateRestaurant, { isLoading, isSuccess }] =
    useCreateRestaurantMutation();

  const [
    requestConfirmSessionId,
    {
      isSuccess: isConfirmSuccess,
      data: confirmData = { success: true, data: { email: "" } },
    },
  ] = useConfirmSessionIdMutation();

  const success = confirmData?.success;
  const email = confirmData?.data?.email;

  const onFinish = async (values) => {
    try {
      if (!sessionId) return;
      await requestCreateRestaurant({
        ...values,
        sessionId,
        tenantId: "tenant id",
      }).unwrap();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success("Your account has been created successfully");
      navigate("/login");
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (sessionId) {
      requestConfirmSessionId({ sessionId });
    }
  }, [sessionId, requestConfirmSessionId]);

  useEffect(() => {
    if (!isConfirmSuccess) return;
    if (!success) {
      navigate("/create-account");
      return;
    }
    if (email) {
      form.setFieldValue("email", email);
    }
  }, [isConfirmSuccess, success, email, form, navigate]);

  return (
    <div className="signincontainer signup-page auth-page">
      <div className="saas-card auth-card" style={{ maxWidth: 560 }}>
        <div className="auth-brand">
          <div className="auth-logo-wrap">
            <img src="/mark1.jpg" alt="SFBB Pro" />
          </div>
        </div>

        <div className="auth-heading">Set up your business</div>
        <p className="auth-copy">
          Thanks for subscribing. Enter your account details to finish setup.
        </p>

        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          className="auth-form"
          requiredMark={false}
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please enter your account email" },
            ]}
          >
            <Input
              className="auth-input"
              placeholder="Email address"
              size="large"
              disabled
            />
          </Form.Item>

          <Form.Item
            name="name"
            label="Business name"
            rules={[
              { required: true, message: "Please enter a business name" },
            ]}
          >
            <Input
              placeholder="Business name"
              className="auth-input"
              size="large"
            />
          </Form.Item>

          <Row gutter={12}>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["address", "street"]}
                label="Street"
                rules={[
                  { required: true, message: "Please enter the street" },
                ]}
              >
                <Input
                  placeholder="Street"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["address", "city"]}
                label="City"
                rules={[{ required: true, message: "Please enter the city" }]}
              >
                <Input
                  placeholder="City"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["address", "country"]}
                label="Country"
                rules={[
                  { required: true, message: "Please enter the country" },
                ]}
              >
                <Input
                  placeholder="Country"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["address", "pincode"]}
                label="Postcode"
                rules={[
                  { required: true, message: "Please enter the postcode" },
                ]}
              >
                <Input
                  placeholder="Postcode"
                  className="auth-input"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>

          <Button
            htmlType="submit"
            size="large"
            block
            loading={isLoading}
            className="signup-cta-btn"
          >
            Create account
          </Button>
        </Form>
      </div>
    </div>
  );
}
